import React, { ChangeEvent, FunctionComponent, useState } from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import { validateForm } from 'pages/administration/locations/utils';
import i18n from 'i18n';
import TextField from 'components/TextField';

interface FormI {
  location?: $Lns.Location;
  onSave: (formData: $Lns.Location) => void;
  onCancel: () => void;
}

const Form: FunctionComponent<FormI> = ({
  location,
  onSave,
  onCancel
}: FormI) => {
  const [formData, setFormData] = useState({
    id: location?.id,
    guid: location?.guid || '',
    city: location?.city || '',
    country: location?.country || '',
    errors: {
      city: '',
      country: ''
    }
  });

  const onChangeField = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    const updatedFormData = {
      ...formData,
      [name]: value,
      errors: {
        ...formData.errors,
        [name]: validateForm(name, value)
      }
    };
    toggleSaveBtn(updatedFormData, location, name);
    setFormData(updatedFormData);
  };

  const toggleSaveBtn = (
    updatedFormData: any, // eslint-disable-line
    origFormData: any, // eslint-disable-line
    key: string
  ) => {
    let checkFlg = true;
    const skipList = ['errors', 'schedule'];
    if (origFormData && Object.keys(origFormData).includes(key)) {
      const tempFormData = { ...updatedFormData };
      checkFlg = checkFormDataState(origFormData, tempFormData, skipList);
      setBtnDisabledChange(checkFlg);
    }
  };

  const checkFormDataState = (
    formDataObj: $Lns.Location,
    updateFormDataObj: any, // eslint-disable-line
    skipList: string[]
  ) => {
    let checkFlg = true;
    Object.keys(updateFormDataObj).forEach(pin => {
      if (
        pin in updateFormDataObj &&
        pin in formDataObj &&
        !skipList.includes(pin)
      ) {
        const Val1 = updateFormDataObj[pin as keyof typeof updateFormDataObj];
        const Val2 = formDataObj[pin as keyof typeof formDataObj];
        if (Val1 !== Val2) {
          checkFlg = false;
        }
      }
    });
    return checkFlg;
  };

  const btnDisabled =
    Object.values(formData.errors).some(e => !!e) || !formData.city;

  const [BtnDisabledChange, setBtnDisabledChange] = useState(
    Object.values(formData.errors).some(e => !!e) || !!formData.city
  );

  return (
    <Box padding={4}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="country"
            label={i18n.t('pages.administration.locations.formLabel.country')}
            value={formData.country}
            helperText={formData.errors.country}
            name="country"
            onChange={onChangeField}
            error={!!formData?.errors?.country}
            autoComplete="country"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="city"
            label={i18n.t('pages.administration.locations.formLabel.city')}
            value={formData.city}
            helperText={formData.errors.city}
            name="city"
            onChange={onChangeField}
            error={!!formData?.errors?.city}
            autoComplete="city"
          />
        </Grid>
        <Grid item container spacing={2} justify="flex-end">
          <Grid item>
            <Button color="secondary" variant="outlined" onClick={onCancel}>
              {i18n.t('button.cancel')}
            </Button>
          </Grid>
          <Grid item>
            <Button
              disabled={btnDisabled || BtnDisabledChange}
              color="secondary"
              variant="contained"
              onClick={() => onSave(formData)}
            >
              {i18n.t('button.save')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Form;

Form.defaultProps = {
  location: undefined
};
